import * as React from 'react';
import isObject from 'lodash/isObject';

import './tile-standard-header-details-section.scss';

type Props = {
  label: string,
  value: string | React.ReactNode,
  isBlocked?: boolean
};

const TileStandardHeaderDetailsSection = ({
  label,
  value,
  isBlocked
}: Props): JSX.Element => {
  const blurredValue = 'xxx';
  const updatedValue = isBlocked ? blurredValue : value;

  return (
    <div
      className="tile-standard-header-details-section"
      title={`${!isObject(updatedValue) ? `${label}: ${String(updatedValue)}` : ''}`}
    >
      <div className="tile-standard-header-details-section__label">
        {label}:
      </div>
      <div className="tile-standard-header-details-section__value text-overflow-ellipsis">
        {updatedValue}
      </div>
    </div>
  );
};

export default TileStandardHeaderDetailsSection;
